import BookmarkIcon from '@material-ui/icons/Bookmark';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';

const SubtitleIconRightColumn = ({ index, rowData, updateSub, removeSub }) => (
    <div
        id={`icon${index}`}
        style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            width: '30px',
        }}
    >
        <BookmarkIcon
            id={`bookmarkIcon${index}`}
            style={{
                fontSize: '19px',
                marginRight: '10px',
                cursor: 'pointer',
                color: rowData?.bookmark ? 'orange' : null,
            }}
            onClick={() => {
                if (!rowData) return;

                const isBookmarked = rowData.bookmark;

                updateSub(rowData, {
                    bookmark: !isBookmarked,
                });
            }}
        />

        <DeleteIcon
            style={{ fontSize: '19px', marginRight: '10px', cursor: 'pointer' }}
            onClick={() => removeSub(rowData)}
        />
    </div>
);

export default SubtitleIconRightColumn;
